module.exports = __webpack_public_path__ + "img/animal-1.cbca5186.png";